import React from 'react';
import { PrismicRichText } from '@prismicio/react';
import styled from 'styled-components';
import WidthWrapper from './WidthWrapper';

const StyledHeading = styled.div`
  background: ${(props) =>
    props.orange
      ? 'var(--primary)'
      : props.neutral100
      ? 'var(--neutral100)'
      : props.neutral200
      ? 'var(--neutral200)'
      : 'var(--white)'};
  color: ${(props) => (props.orange ? 'var(--white)' : 'var(--black)')};
`;

const WithLine = styled.div`
  justify-content: ${(props) => (props.leftAligned ? '' : 'center')};
  display: flex;
  align-items: center;
  width: 100%;
  text-align: center;
  padding: 3.625rem 0;
  text-transform: uppercase;

  .heading {
    width: fit-content;
  }

  :before,
  :after {
    border-top: 1px solid;
    content: '';
    border-top: 1px solid;
    border-color: ${(props) =>
      props.orange ? 'var(--white)' : props.neutral200 ? 'var(--primary)' : 'var(--black)'};
    flex: 1 0 2rem;
  }

  :before {
    margin-right: 2rem;
    display: ${(props) => props.leftAligned && 'none'};
  }

  :after {
    margin-left: 2rem;
  }

  @media only screen and (max-width: 500px) {
    justify-content: center;

    :before,
    :after {
      display: block;
    }
  }
`;

const WithBrow = styled.div`
  text-align: ${(props) => (props.leftAligned ? '' : 'center')};
  align-items: ${(props) => (props.leftAligned ? 'flex-start' : 'center')};
  margin: ${(props) => (props.leftAligned ? '' : '0 auto')};
  padding: 2rem ${(props) => (props.widthWrapper ? '2rem' : '0')};
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 60rem;

  .description {
    text-align: ${(props) => (props.leftAligned ? '' : 'center')};
    text-transform: none;
    margin: 0 auto;
  }
`;

const StyledPlainHeading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 4rem auto;
  text-align: center;
`;

const Heading = ({
  headingText,
  browText,
  headingLevel,
  withLine,
  orange,
  neutral100,
  neutral200,
  description,
  widthWrapper = false,
  leftAligned,
}) => {
  const HeadingTag = `h${headingLevel || 3}`;

  return (
    <StyledHeading
      className="styled-heading"
      orange={orange}
      neutral100={neutral100}
      neutral200={neutral200}
    >
      {withLine &&
        (widthWrapper ? (
          <WidthWrapper>
            <WithLine
              className="with-line"
              withLine={withLine}
              leftAligned={leftAligned}
              widthWrapper={widthWrapper}
              orange={orange}
              neutral100={neutral100}
              neutral200={neutral200}
            >
              <HeadingTag className="heading heading-xl-ultralight">{headingText}</HeadingTag>
            </WithLine>
          </WidthWrapper>
        ) : (
          <WithLine
            className="with-line"
            withLine={withLine}
            leftAligned={leftAligned}
            widthWrapper={widthWrapper}
            orange={orange}
            neutral100={neutral100}
            neutral200={neutral200}
          >
            <HeadingTag className="heading heading-xl-ultralight">{headingText}</HeadingTag>
          </WithLine>
        ))}

      {(browText || description) && (
        <WithBrow
          className="with-brow"
          leftAligned={leftAligned}
          widthWrapper={widthWrapper}
          orange={orange}
          neutral100={neutral100}
          neutral200={neutral200}
        >
          {browText && <span className="brow heading-xs-semibold">{browText}</span>}
          <HeadingTag className="heading-2xl-ultralight">{headingText}</HeadingTag>
          {description && typeof description === 'object' ? (
            <PrismicRichText field={description} />
          ) : (
            <p className="description body-m-regular ">{description}</p>
          )}
        </WithBrow>
      )}

      {!browText && !description && !withLine && (
        <StyledPlainHeading>
          <HeadingTag className="heading-2xl-ultralight">{headingText}</HeadingTag>
        </StyledPlainHeading>
      )}
    </StyledHeading>
  );
};

export default Heading;
